// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"styles_dropdown__BkmWC","profile":"styles_profile__3rBFD","names":"styles_names__1u9cW","item":"styles_item__1JLSS"};